import { QUERY_PARAMS } from '@/constants';
import type { TDevice } from '@/modules/shared/utils/deviceDetections';
import {
  getQueryParam,
  isAnalyticsReadyToUse
} from '@/modules/shared/utils/deviceDetections';
import type {
  ShippingEvent,
  ShippingEventKeys
} from '@/modules/shared/utils/gtmEvents/types';
import { EWebViewNameEvent } from '@/modules/shared/utils/gtmEvents/types';

const getWebViewNameEvent = (event: ShippingEventKeys): string => {
  if (event === 'baseEvent') {
    return 'event-interactive';
  }
  if (event === 'pageEvent') {
    return EWebViewNameEvent.ACTION_PAGE_EVENT;
  }
  if (event === 'products_not_unavailable_shipping') {
    return EWebViewNameEvent.ACTION_CHECKOUT_PRODUCTS_NOT_UNAVAILABLE_SHIPPING;
  }
  if (event === 'measure_grouping_leadtime') {
    return EWebViewNameEvent.ACTION_CHECKOUT_MEASURE_GROUPING_LEADTIME;
  }
  if (event === 'add_shipping_info') {
    return EWebViewNameEvent.ACTION_CHECKOUT_ADD_INFO;
  }
  if (event === 'begin_checkout') {
    return EWebViewNameEvent.ACTION_PRE_CHECKOUT_APPLIANCE;
  }
  if (event === 'add_to_cart') {
    return EWebViewNameEvent.ACTION_ADD_TO_CART;
  }
  if (event === 'remove_from_cart') {
    return EWebViewNameEvent.ACTION_REMOVE_FROM_CART;
  }
  return 'event-interactive';
};

const sendIosEvent = (
  event: ShippingEventKeys,
  eventObj: ShippingEvent
): void => {
  const device = getQueryParam(QUERY_PARAMS.DEVICE) as TDevice;
  isAnalyticsReadyToUse(device);

  const webViewName = getWebViewNameEvent(event);
  const message = {
    command: 'logEvent',
    name: webViewName,
    parameters: eventObj
  };
  window?.webkit?.messageHandlers?.firebase?.postMessage(message);
};

const sendAndroidEvent = (
  event: ShippingEventKeys,
  eventObj: ShippingEvent
): void => {
  const device = getQueryParam(QUERY_PARAMS.DEVICE) as TDevice;
  isAnalyticsReadyToUse(device);

  const webViewName = getWebViewNameEvent(event);
  const object = JSON.stringify(eventObj);
  window?.AnalyticsWebInterface?.logEvent(webViewName, object);
};

export { sendAndroidEvent, sendIosEvent };
